import queryString from 'query-string';
import xhr from 'xhr';
import storage from '../lib/storage';

/**
 * Save a project JSON to the project server.
 * This should eventually live in scratch-www.
 * @param {number} projectId the ID of the project, null if a new project.
 * @param {object} vmState the JSON project representation.
 * @param {object} params the request params.
 * @property {?number} params.originalId the original project ID if a copy/remix.
 * @property {?boolean} params.isCopy a flag indicating if this save is creating a copy.
 * @property {?boolean} params.isRemix a flag indicating if this save is creating a remix.
 * @property {?string} params.title the title of the project.
 * @return {Promise} A promise that resolves when the network request resolves.
 */
export default function (projectId, thumbnailBlob ,dataURI) {
	console.log(projectId,"projectId");
	console.log(thumbnailBlob,"thumbnailBlob");
 	
	var accessid= 'LTAI4FweuttcF2AM4RqYdKFF';
	var accesskey= 'OOS2jxjhAAt3mClD8SeOxT2M39KdqG';
	var host = 'http://static.sahalatec.cn';

	var g_dirname = '';
	var g_object_name = '';
	var g_object_name_type = '';
	var timestamp = Date.parse(new Date()) / 1000; 
	var now = timestamp;
	var policyText = {
		"expiration": "2030-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
		"conditions": [
			["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
		]
	};

	var policyBase64 = Base64.encode(JSON.stringify(policyText));
	var message = policyBase64;
	var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true }) ;
	var signature = Crypto.util.bytesToBase64(bytes);


	var thumbnail = new FormData();
/*  thumbnail.append("name", "file_"+Date.parse(new Date())+".png");
    thumbnail.append("key", "assest/file_"+Date.parse(new Date())+".png");
    thumbnail.append("policy", policyBase64);
    thumbnail.append("OSSAccessKeyId", accessid);
    thumbnail.append("success_action_status", 200);
    thumbnail.append("signature", signature); 
    thumbnail.append("file", thumbnailBlob,"file_"+Date.parse(new Date())+".png");*/
    thumbnail.append("image", thumbnailBlob,"file_"+Date.parse(new Date())+".png");
	

	const opts = {
        body:thumbnail
    };
	
	Object.assign(opts, {
            method: 'post',
            url: `/portal/scratch/savethumbnail?projectId=${projectId}`
             //url: host
        });
		
    return new Promise((resolve, reject) => {
        xhr(opts, (err, response) => {
            if (err) return reject(err);
            if (response.statusCode !== 200) return reject(response.statusCode);
            let body;
            try {
				console.log(response,22222);
                // Since we didn't set json: true, we have to parse manually
                body = JSON.parse(response.body);
            } catch (e) {
                return reject(e);
            }
          
            resolve(body);
        });
    });
}
